module.exports = __webpack_public_path__ + "static/media/5-c_old.dae4e08b.png";